import { render, staticRenderFns } from "./DomesticDriverSalaryView.vue?vue&type=template&id=20c0b21f&"
import script from "./DomesticDriverSalaryView.vue?vue&type=script&lang=js&"
export * from "./DomesticDriverSalaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports